export default {
      id: "file-type-audio-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#file-type-audio",
      toString: function () {
        return this.url;
      }
    }